import { useMemo } from "react";
import { compose, isNotNil, allPass, prop } from 'ramda';

import RefCardsCarousel from "../../../components/refCardsCarousel/refCardsCarousel";
import SBEditable from "../../../components/sbEditable/sbEditable";
import ArticleListingCard from "../../../components/articleListingCard/articleListingCard";
import { GetImageUrlAndTagSize } from "../../../components/storyblokImageBasic/storyblokImageBasic";

import { useStoryblokGlobalSettings } from "../../../hooks/useStoryblokGlobalSettings";

import styles from "./customTagPanel.module.scss";
import { useStoryblokArticlesSearch } from "../../../hooks/useStoryblokArticlesSearch";

const hasDeps = allPass([
  compose(isNotNil, prop('category_filter')),
  compose(isNotNil, prop('type_filter'))
])

function CustomTagPanel({ blok }) {
  const globalSettings = useStoryblokGlobalSettings();

  if (!hasDeps(blok)) return null;

  const [articles, total, isLoading] = useStoryblokArticlesSearch({
    category: blok.category_filter,
    type: blok.type_filter,
    tag: blok.tag_filter.artcile_tag,
  });

  const articleList = articles ? articles.slice(0, blok.item_count) : [];

  let bgImage = useMemo(() => {
    if (globalSettings && globalSettings.custom_tag_panel_background_image) {
      const { url } = GetImageUrlAndTagSize(
        globalSettings.custom_tag_panel_background_image
      );
      return url;
    }
    return "";
  }, [globalSettings]);
  let yuzuImage = useMemo(() => {
    if (globalSettings && globalSettings.custom_tag_panel_yuzu_image) {
      const { url } = GetImageUrlAndTagSize(
        globalSettings.custom_tag_panel_yuzu_image
      );
      return url;
    }
    return "";
  }, [globalSettings]);

  if (!isLoading && articles.length === 0) {
    return null;
  }

  return (
    <SBEditable
      blok={blok}
      withClass={`${styles.customTagPanel} ${
        blok.margin_top ? styles.marginTopDefault : ""
      } ${blok.margin_bottom ? styles.marginBottomDefault : ""}`}
    >
      <div
        className={styles.background}
        style={{ backgroundImage: `url("${bgImage}")` }}
      >
        <div className={`page-content ${styles.pageContent}`}>
          <div className={styles.carouselArea}>
            <h2 className={styles.headline}>{blok.headline}</h2>
            {isLoading ? <div className="loader centered" /> : null}
            <div className={styles.carouselWrapper}>
              {yuzuImage ? (
                <img src={yuzuImage} className={styles.yuzuImage} />
              ) : null}
              {articleList && articleList.length ? (
                <RefCardsCarousel
                  arrowClass={styles.carouselArrows}
                  extraSmallOptions={{ perPage: 1, gap: "14px" }}
                  mobileOptions={{ perPage: 1, gap: "14px" }}
                  mobileExtendedOptions={{ perPage: 1, gap: "14px" }}
                  smallTabletOptions={{ perPage: 2, gap: "25px" }}
                  tabletOptions={{ perPage: 3, gap: "25px" }}
                  desktopOptions={{ perPage: 4, gap: "25px" }}
                >
                  {articleList.map((a) => (
                    <ArticleListingCard
                      key={a.uuid}
                      layout="featured_custom_tag_panel"
                      slug={a.slug}
                      thumbnail={a.content.thumbnail}
                      authors={a.content.authors}
                      title={a.content.headline}
                      date={a.content.created_at}
                      article_category={a.content.category}
                      article_type={a.content.article_type}
                      comment_count={5}
                      enable_comments={a.content.has_comments}
                      enable_social_sharing={a.content.has_social_sharing}
                      use_legacy_thumbnail_background={
                        a.content.legacy_thumbnail_background
                      }
                    />
                  ))}
                </RefCardsCarousel>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </SBEditable>
  );
}

export default CustomTagPanel;
